import { useState, useEffect } from 'react';

import sidebarData from 'components/Sidebar/SidebarData';
import { routePaths } from 'global/routePaths';
import { useFeatureList } from 'store/useFeatureStore';
import { useCompanyInfo } from 'store/useUserStore';
import { allowedRoute } from 'utils/allowedRoutes';

export function useAllowedSidebarData() {
  const [allowedSideBarData, setAllowedSidebarData] = useState<any>([]);
  const companyInfo = useCompanyInfo();
  const featureList = useFeatureList();

  useEffect(() => {
    const newSidebar = sidebarData.filter(({ access, path, featureName }: any) => {
      // Hide jobs and tasks routes if companyInfo requiresJobs field is false
      if (path === routePaths.evv.base.route && !companyInfo?.evvSetting?.has_evv) {
        return false;
      }

      // // Hide time off if companyInfo showTimeOff is set to 0
      // if (path === routePaths.timeOff.base.route && !companyInfo?.showTimeOff) {
      //   return false;
      // }

      if (featureName && !featureList[featureName]) {
        return false;
      }

      return allowedRoute(access);
    });

    setAllowedSidebarData(newSidebar);
  }, [companyInfo?.evvSetting?.has_evv, companyInfo?.showTimeOff, featureList]);

  return { allowedSideBarData };
}
